// @flow
/**
 * Created by ivo on 08.01.17.
 *
 * NCP files parser
 */

import GlassFileParser from './GlassFileParser';
import t from './trans';

/**
 * NCP file parser
 *
 * Supports the following commands in this G-file:
 * G01 - Linear Feed Move (X, Y, Z)
 * G02 - Clockwise Arc Feed Move (X, Y, Z, R)
 * G03 - Counter Clockwise Arc Feed Move (X, Y, Z, R)
 * G05 - ???
 */
class NcpFileParser extends GlassFileParser {
    constructor(isRotated) {
        super();
        this.rotated = isRotated;
    }

    /**
     * Parses glass data file
     */
    parseData() {
        // Vt rida 4061 failis ncp2gr.frm

        // Esimene rida on '%'
        let l = this.readLine();
        if (l !== "%") throw t("Invalid data, missing start signature on line %s", this.lineno);

        // Teine rida on nimetus (alates teisest positsioonist);
        l = this.readLine();
        this.label = l.substring(1);

        // Igonreerime kõiki ridu, mis ei oma rea alguses "G05":
        l = this.readLine();
        while (l.substring(0, 3) !== "G05") {
            l = this.readLine();
        }

        let i = 0;
        this.joonsuund = [];
        this.raadius = [];
        this.joonx1 = [];
        this.joonx2 = [];
        this.joony1 = [];
        this.joony2 = [];

        l = this.readLine();
        this.joonsuund[i] = l.substring(0, 3);

        let re01 = /^G01 ?X([-0-9.]+) ?Y([-0-9.]+) ?Z([-0-9.]+)/i;
        let re02 = /^G0[2-3] ?X([-0-9.]+) ?Y([-0-9.]+) ?Z([-0-9.]+) ?R([-0-9.]+)$/i;

        while (this.joonsuund[i] !== "G05") {
            if (this.joonsuund[i] == "G01" || this.joonsuund[i] == "G02" || this.joonsuund[i] == "G03") {
                let info = l.match((this.joonsuund[i] === "G01" ? re01 : re02));
                if (!info) throw t("Invalid data on line %s", this.lineno);

                if (this.rotated) {
                    this.joonx2[i] = Number.parseFloat(info[1]);
                    this.joonx1[i+1] = this.joonx2[i];
                    this.joony2[i] = Number.parseFloat(info[2]);
                    this.joony1[i+1] = this.joony2[i];
                } else {
                    this.joony2[i] = Number.parseFloat(info[1]);
                    this.joony1[i+1] = this.joony2[i];
                    this.joonx2[i] = Number.parseFloat(info[2]);
                    this.joonx1[i+1] = this.joonx2[i];
                }

                if (this.joonsuund[i] !== "G01") {
                    this.raadius[i] = Number.parseFloat(info[4]);
                    // NB! Seda tuleb teha ainult Poola failide korral:
                    if (this.rotated) {
                        if (this.joonsuund[i] === "G02") this.joonsuund[i] = "G03";
                        else this.joonsuund[i] = "G02";
                    }
                }
                i++;
            }

            l = this.readLine();
            this.joonsuund[i] = l.substring(0, 3);
        }
        this.ridu = i;
        // Laseme faili sisu hoidva mälu lahti:
        this.resetInputData();

        this.joonx1[0] = this.joonx2[this.ridu-1];
        this.joony1[0] = this.joony2[this.ridu-1];

        this.kandiline = true;
        while (this.kandiline) this.kaaresta();

    }

    kaaresta() {
        this.kandiline = false;

        let ajutx1 = [];
        let ajuty1 = [];
        let ajutx2 = [];
        let ajuty2 = [];
        let ajutr = [];
        let ajutsuund = [];

        let ajut_i = 0;
        for (let i = 0; i < this.ridu; i++) {
            if (this.joonsuund[i] !== "G01") {
                let abia = (((this.joonx2[i] - this.joonx1[i]) * (this.joonx2[i] - this.joonx1[i])) + ((this.joony2[i] - this.joony1[i]) * (this.joony2[i] - this.joony1[i])));
                let a = Math.sqrt(abia) / 2;
                if (a > 10) {
                    this.kandiline = true;
                    let x3 = (this.joonx1[i] + this.joonx2[i]) / 2;
                    let y3 = (this.joony1[i] + this.joony2[i]) / 2;
                    let d = this.raadius[i] - Math.sqrt(((this.raadius[i] * this.raadius[i]) - (a * a)));
                    let alfa = 0;
                    if (this.joonx1[i] == this.joonx2[i]) alfa = Math.PI / 4;
                    else alfa = Math.atan(Math.abs((this.joony2[i] - this.joony1[i]) / (this.joonx2[i] - this.joonx1[i])));

                    let x4 = 0;
                    let y4 = 0;

                    if (this.joonx2[i] >= this.joonx1[i] && this.joony2[i] >= this.joony1[i]) {
                        if (this.joonsuund[i] == "G03") {
                            x4 = x3 - (d * Math.sin(alfa));
                            y4 = y3 + (d * Math.cos(alfa));
                        } else {
                            x4 = x3 + (d * Math.sin(alfa));
                            y4 = y3 - (d * Math.cos(alfa));
                        }
                    }

                    if (this.joonx2[i] < this.joonx1[i] && this.joony2[i] > this.joony1[i]) {
                        if (this.joonsuund[i] == "G03") {
                            x4 = x3 - (d * Math.sin(alfa));
                            y4 = y3 - (d * Math.cos(alfa));
                        } else {
                            x4 = x3 + (d * Math.sin(alfa));
                            y4 = y3 + (d * Math.cos(alfa));
                        }
                    }

                    if (this.joonx2[i] <= this.joonx1[i] && this.joony2[i] <= this.joony1[i]) {
                        if (this.joonsuund[i] == "G03") {
                            x4 = x3 + (d * Math.sin(alfa));
                            y4 = y3 - (d * Math.cos(alfa));
                        } else {
                            x4 = x3 - (d * Math.sin(alfa));
                            y4 = y3 + (d * Math.cos(alfa));
                        }
                    }

                    if (this.joonx2[i] > this.joonx1[i] && this.joony2[i] < this.joony1[i]) {
                        if (this.joonsuund[i] == "G03") {
                            x4 = x3 + (d * Math.sin(alfa));
                            y4 = y3 + (d * Math.cos(alfa));
                        } else {
                            x4 = x3 - (d * Math.sin(alfa));
                            y4 = y3 - (d * Math.cos(alfa));
                        }
                    }

                    ajutx1[ajut_i] = this.joonx1[i];
                    ajuty1[ajut_i] = this.joony1[i];
                    ajutx2[ajut_i] = x4;
                    ajuty2[ajut_i] = y4;
                    ajutr[ajut_i] = this.raadius[i];
                    ajutsuund[ajut_i] = this.joonsuund[i];
                    ajut_i = ajut_i + 1;
                    ajutx1[ajut_i] = x4;
                    ajuty1[ajut_i] = y4;
                    ajutx2[ajut_i] = this.joonx2[i];
                    ajuty2[ajut_i] = this.joony2[i];
                    ajutr[ajut_i] = this.raadius[i];
                    ajutsuund[ajut_i] = this.joonsuund[i];
                    ajut_i = ajut_i + 1;
                } else {
                    ajutx1[ajut_i] = this.joonx1[i];
                    ajuty1[ajut_i] = this.joony1[i];
                    ajutx2[ajut_i] = this.joonx2[i];
                    ajuty2[ajut_i] = this.joony2[i];
                    ajutr[ajut_i] = this.raadius[i];
                    ajutsuund[ajut_i] = this.joonsuund[i];
                    ajut_i = ajut_i + 1;
                }
            } else {
                ajutx1[ajut_i] = this.joonx1[i];
                ajuty1[ajut_i] = this.joony1[i];
                ajutx2[ajut_i] = this.joonx2[i];
                ajuty2[ajut_i] = this.joony2[i];
                ajutr[ajut_i] = this.raadius[i];
                ajutsuund[ajut_i] = this.joonsuund[i];
                ajut_i = ajut_i + 1;
            }
        }
        this.ridu = ajut_i;
        for (let i = 0; i < this.ridu; i++) {
            this.joonx1[i] = ajutx1[i];
            this.joony1[i] = ajuty1[i];
            this.joonx2[i] = ajutx2[i];
            this.joony2[i] = ajuty2[i];
            this.joonsuund[i] = ajutsuund[i];
            this.raadius[i] = ajutr[i];
        }
    }

}

export default NcpFileParser;
